import { erc20Abi, PublicClient, formatUnits } from 'viem'
import { to0xString } from './toHex'

/**
 * 获取代币余额（支持3个独立参数）
 */
const getTokenAmount = async (
  account: string,
  tokenAddress: string,
  publicClient: PublicClient
): Promise<bigint> => {
  try {
    const balance = await publicClient.readContract({
      address: to0xString(tokenAddress),
      abi: erc20Abi,
      functionName: 'balanceOf',
      args: [to0xString(account)],
      authorizationList: undefined
    }) as bigint

    return balance
  } catch (error) {
    console.error('获取代币余额失败:', error)
    throw new Error('Failed to get token balance')
  }
}

export default getTokenAmount